import React, { useCallback } from 'react';
import { useRouteMatch } from 'react-router';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

import { StudioControlStyles } from '../styles';
import { Button, Link } from '../..';
import { clipLastSegmentRoute } from '../../../utility/path';
import { setOpenStudio } from '../../../store/modules/studio/actions';
import StudioToolTip from './StudioToolTip';

const ExitStudioAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const exitStudio = useCallback(() => {
    window.studioAudioService?.close();
    dispatch(setOpenStudio(false));
  }, [dispatch]);

  return (
    <Grid item className={classes.exitButtonWrapper}>
      <Link onClick={exitStudio} to={clipLastSegmentRoute(url)} className={classes.link}>
        <StudioToolTip title="Exit the Studio mode">
          <Button
            className={clsx(classes.button, classes.exitButton)}
            data-intercom-target="Button: Exit Studio"
          >
            Exit Studio
          </Button>
        </StudioToolTip>
      </Link>
    </Grid>
  );
};

export default ExitStudioAction;
